import { Image } from '@gousto-internal/citrus-react'
import React from 'react'
import { FourWayImageTile, ImageWrapper } from './FourWayImage.styled'

export type FourWayImageProps = {
  curatedBoxImgUrls: (string | undefined)[]
}
export const FourWayImage = ({ curatedBoxImgUrls }: FourWayImageProps) => (
  <FourWayImageTile>
    {curatedBoxImgUrls?.map((curatedBoxImgUrl) => (
      <ImageWrapper key={curatedBoxImgUrl}>
        <Image fit="cover" key={curatedBoxImgUrl} alt="" src={curatedBoxImgUrl} />
      </ImageWrapper>
    ))}
  </FourWayImageTile>
)
